/**
 * Função de utilidade que atua como um Array.filter em childNodes de "container""
 * @param {HTMLElement} container
 * @param {string} s_tag
 */
function find_sub_child_sibling_node(container, s_tag) {
  if (!container || !s_tag) return false;
  const child_nodes = container.childNodes;
  for (let i = 0; i < child_nodes.length; i++) {
    if (child_nodes[i].s_tag == s_tag) return child_nodes[i];
  }
  return false;
}

/**
 * Esta função move cada sub-filho do argumento "child" para o início de "child_sibling"
 * argumento, a partir do último filho, com divisão de palavras e preservação de formato.
 * Normalmente, "child" é a página atual cujo conteúdo transborda, e "child_sibling" é o
 * próxima página.
 * @param {HTMLElement} child Elemento para retirar os filhos (página atual)
 * @param {HTMLElement} child_sibling Elemento para o qual copiar os filhos (próxima página)
 * @param {Function} stop_condition Verifique a função que retorna um booleano se o conteúdo não estourar mais
 * @param {Boolean} not_first_child Não deve ser definido. Usado internamente para permitir que pelo menos um filho na página
 */
function move_children_forward_recursively(
  child,
  child_sibling,
  stop_condition,
  not_first_child
) {
  // if the child still has nodes and the current page still overflows
  while (child.childNodes.length && !stop_condition()) {
    // verifique se a página tem apenas uma árvore filha restante
    not_first_child = not_first_child || child.childNodes.length != 1;

    // selecione o último sub-filho
    const sub_child = child.lastChild;

    //se for um nó de texto, mova seu conteúdo para a próxima página, palavra (/ espaço) por palavra
    if (sub_child.nodeType == Node.TEXT_NODE) {
      const sub_child_hashes = sub_child.textContent.match(/(\s|\S+)/g);
      const sub_child_continuation = document.createTextNode("");
      child_sibling.prepend(sub_child_continuation);
      const l = sub_child_hashes ? sub_child_hashes.length : 0;
      for (let i = 0; i < l; i++) {
        if (i == l - 1 && !not_first_child) return; // never remove the first word of the page
        sub_child.textContent = sub_child_hashes.slice(0, l - i - 1).join("");
        sub_child_continuation.textContent = sub_child_hashes
          .slice(l - i - 1, l)
          .join("");
        if (stop_condition()) return;
      }
    }

    // se for um nó sem conteúdo (por exemplo, <img>), ou um título de cabeçalho (por exemplo, <h1>), simplesmente o movemos
    else if (!sub_child.childNodes.length || sub_child.tagName.match(/h\d/i)) {
      // just prevent moving the last child of the page
      if (!not_first_child) {
        return;
      }
      child_sibling.prepend(sub_child);
    }

    // para cada outro nó que não é texto e não é o primeiro filho, clone-o recursivamente para a próxima página
    else {
      // verifique se o sub filho já foi clonado antes
      let sub_child_sibling = find_sub_child_sibling_node(
        child_sibling,
        sub_child.s_tag
      );

      // caso contrário, crie-o e marque o relacionamento com uma tag aleatória
      if (!sub_child_sibling) {
        if (!sub_child.s_tag) {
          const new_random_tag = Math.random().toString(36).slice(2, 8);
          sub_child.s_tag = new_random_tag;
        }
        sub_child_sibling = sub_child.cloneNode(false);
        sub_child_sibling.s_tag = sub_child.s_tag;
        child_sibling.prepend(sub_child_sibling);
      }

      // em seguida, mover / clonar seus filhos e sub-filhos recursivamente
      move_children_forward_recursively(
        sub_child,
        sub_child_sibling,
        stop_condition,
        not_first_child
      );
      sub_child_sibling.normalize(); // mesclar nós de texto consecutivos
    }

    // se sub_child era um contêiner que foi clonado e agora está vazio, nós o limpamos
    if (child.contains(sub_child)) {
      if (sub_child.childNodes.length == 0 || sub_child.innerHTML == "")
        child.removeChild(sub_child);
      else if (!stop_condition()) {
        // o único caso em que pode não estar vazio deve ser quando stop_condition agora é verdadeiro
        throw Error(
          "O editor de documentos está tentando remover um sub-filho não vazio. Esse " +
            "é um bug e não deveria acontecer. Relate um conjunto repetível de ações que " +
            "levou a este erro para ADM"
        );
      }
    }
  }
}

/**
 * Esta função move o primeiro elemento de "next_page_html_div" para o final de "page_html_div", com
 * mesclando tags irmãs com marca d'água anterior de "move_children_forward_recursively", se houver.
 * @param {HTMLElement} page_html_div Elemento da página atual
 * @param {HTMLElement} next_page_html_div Elemento da próxima página
 * @param {Function} stop_condition CVerifique a função que retorna um booleano se o conteúdo estourar
 */
function move_children_backwards_with_merging(
  page_html_div,
  next_page_html_div,
  stop_condition
) {
  // loop until content is overflowing
  while (!stop_condition()) {
    // find first child of next page
    const first_child = next_page_html_div.firstChild;

    // merge it at the end of the current page
    var merge_recursively = (container, elt) => {
      // check if child had been splitted (= has a sibling on previous page)
      const elt_sibling = find_sub_child_sibling_node(container, elt.s_tag);
      if (elt_sibling && elt.childNodes.length) {
        // then dig for deeper children, in case of
        merge_recursively(elt_sibling, elt.firstChild);
      }
      // else move the child inside the right container at current page
      else {
        container.append(elt);
        container.normalize();
      }
    };
    merge_recursively(page_html_div, first_child);
  }
}

export {
  move_children_forward_recursively,
  move_children_backwards_with_merging,
};
